import { render, staticRenderFns } from "./FacetsFilters.vue?vue&type=template&id=4d2271fe&"
import script from "./FacetsFilters.vue?vue&type=script&lang=js&"
export * from "./FacetsFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports